export default "__VITE_ASSET__D4DD4reM__"